/**
 * Parses error messages from GraphQL mutations to extract clean, user-friendly error text
 */
export function parseErrorMessage(errorMessage: string): string {
  // Try to extract detail from DomainError format
  const domainErrorMatch = errorMessage.match(/detail='([^']+)'/)
  if (domainErrorMatch && domainErrorMatch[1]) {
    return domainErrorMatch[1]
  }

  // Return original message if no parsing pattern matches
  return errorMessage
}
